/**
 * Pálinka fajtája
 */
export type FruitSpiritType = 'SPECIES' | 'MARRIED' | 'HONEY';

export const FruitSpiritType = {
  Species: 'SPECIES' as FruitSpiritType,
  Married: 'MARRIED' as FruitSpiritType,
  Honey: 'HONEY' as FruitSpiritType,
};
